var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("database-management-modal", {
    ref: "modal",
    attrs: { element: _vm.department },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              {
                class: _vm.hasErrorClass(_vm.$v.department.name, "form-group"),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("* Name"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.department.name.$model,
                      expression: "$v.department.name.$model",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    name: "name",
                    type: "text",
                    placeholder: "Marketing",
                  },
                  domProps: { value: _vm.$v.department.name.$model },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.$v.department.name,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: { field: _vm.$v.department.name, label: "Name" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: _vm.hasErrorClass(
                  _vm.$v.department.restricted,
                  "form-group"
                ),
              },
              [
                _c("div", { staticClass: "checkbox checkbox-primary" }, [
                  _c(
                    "div",
                    { staticClass: "input-group-checkbox" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.department.restricted.$model,
                            expression: "$v.department.restricted.$model",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "restricted",
                          name: "restricted",
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.$v.department.restricted.$model
                          )
                            ? _vm._i(
                                _vm.$v.department.restricted.$model,
                                null
                              ) > -1
                            : _vm.$v.department.restricted.$model,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.$v.department.restricted.$model,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.$v.department.restricted,
                                    "$model",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.$v.department.restricted,
                                    "$model",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.$v.department.restricted,
                                "$model",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "restricted" } }, [
                        _vm._v(
                          "\n            Show department for restricted admin request forms only\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("vuelidate-help", {
                        attrs: {
                          field: _vm.$v.department.restricted,
                          label: "Restricted",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "ladda-button",
              {
                staticClass: "btn btn-lg btn-primary pull-right",
                attrs: {
                  click: _vm.saveDepartment,
                  type: "button",
                  "data-dismiss": "modal",
                },
              },
              [_c("i", { staticClass: "fa fa-check" }), _vm._v(" Save")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }